module.exports = __webpack_public_path__ + "img/step-3.f028ed38.png";